import React, { useState } from 'react';
import swal from 'sweetalert';

const Contact = () => {

  let[formData , setIsFormData ] = useState({
    name:'',
    email:'',
    mobileNo:'',
    subject:'',
    message:''
  });
  const handleChange =(e)=>{
    setIsFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  }

  let handleSubmit = async(e)=>{

    e.preventDefault();
    swal('Processing..','Please wait your data in processing','info');
    const username = "G1n7a/GJ+SRW56SSUyMp9U1NTGVvTHE4OHdENjkzWDRRWXcvVkE9PQ==";
    const password = "6LGqKsswH7pxAVhBG9AwbTRlaHJNcWc5am5Td0NGdzhBUWUrblE9PQ==";
    const signature = "954492e7df129de140d6cb63fe6fe7b6d414f4042206d3c115709a5522d52090";
    const url = "https://techbizsoftwaresolutions.com/backend/sendmail.php";

    try{
      const fetchdata = await fetch(url,{
        method:'POST',
        headers:{'content-type':'application/json',
          'Authorization': 'Basic ' + btoa(username + ":" + password),
          'X-Signature': signature
        },
        body: JSON.stringify(formData),
      });
      const responseData = await fetchdata.json();
      if (responseData.status !== 'success') {
        return swal('Error',responseData.message,'error');
      }      
      console.log("Fetch Data"+ responseData);
      swal('Success',responseData.message,'success');
      setIsFormData({name:'',email:'',mobileNo:'',subject:'',message:''});
    }catch(error){
       console.log('Error message:',error);
      swal("Error", "Something went wrong :" + error.message , "error");
    }

  }

  return (
  <section id="contact" class="contact section">

    <div class="container section-title" data-aos="fade-up">
      <h2>Contact Us</h2>
      <p>We're here to help! Whether you have a question, want to discuss a potential project, or need assistance, don't hesitate to get in touch with us. Our team is always ready to assist you.</p>
    </div>
    <div class="container" data-aos="fade-up" data-aos-delay="100">
      <div class="row gy-4">
        <div class="col-lg-5">
          <div class="info-wrap">
            <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
              <i class="bi bi-geo-alt flex-shrink-0"></i>
              <div>
                <h3>Our Office</h3>
                <p>Airoli, Navi Mumbai, Maharashtra- 400708, India</p>
              </div>
            </div>
            <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
              <i class="bi bi-telephone flex-shrink-0"></i>
              <div>
                <h3>Call Us</h3>
                <p>📞 +91 81040 43108</p>
                <p>📞 +91 81694 30874</p>                
              </div>
            </div>
            <div class="info-item" data-aos="fade-up" data-aos-delay="400">
              <div class="d-flex align-items-center mb-2">
                <i class="bi bi-envelope flex-shrink-0 me-2 fs-4"></i>
                <h3 class="mb-0">Email Us</h3>
              </div>
              <ul class="ps-4" style={{fontSize:'13px'}}>
                <li class="mt-2">sales@techbizsoftwaresolutions.com</li>
                <li class="mt-2">contact@techbizsoftwaresolutions.com</li>
                <li class="mt-2">support@techbizsoftwaresolutions.com</li>
              </ul>
            </div>

          </div>
        </div>

        <div class="col-lg-7">
          <form onSubmit={handleSubmit} method="post" class="php-email-form" data-aos="fade-up" data-aos-delay="200">
            <div class="row gy-4">
              <div class="col-md-6">
                <label for="name-field" class="pb-2">Full Name</label>
                <input type="text" name="name" id="name-field" class="form-control" placeholder="Full Name" required="" value={formData.name} onChange={handleChange}/>
              </div>
              <div class="col-md-6">
                <label for="email-field" class="pb-2">Email Address</label>
                <input type="email" class="form-control" name="email" id="email-field" placeholder="Email Address" required="" value={formData.email} onChange={handleChange}/>
              </div>
              <div class="col-md-6">
                <label for="mobile-field" class="pb-2">Mobile</label>
                <input type="text" class="form-control" name="mobileNo" id="mobile-field" placeholder="Mobile Number" required="" value={formData.mobileNo} onChange={handleChange}  pattern="\d{10}" title="Please enter a valid 10-digit mobile number." oninput="this.value = this.value.replace(/[^0-9]/g, '')"/>
              </div>
              <div class="col-md-6">
                <label for="subject-field" class="pb-2">Subject</label>
                <input type="text" class="form-control" name="subject" id="subject-field" placeholder="Subject" required="" value={formData.subject} onChange={handleChange}/>
              </div>
              <div class="col-md-12">
                <label for="message-field" class="pb-2">Message</label>
                <textarea class="form-control" name="message" rows="4" id="message-field" placeholder="Message" required="" value={formData.message} onChange={handleChange}></textarea>
              </div>
              <div class="col-md-12 text-center">
                <button type="submit">Send Message</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Contact
